import Vue from 'vue'

import * as types from './mutation-types'

export default {
  [types.SET_STATISTICS] (state, results) {
    Object.keys(results).forEach(key => {
      Vue.set(state, key, results[key])
    })
  },
  [types.SET_SEARCH_RANGE] (state, { startDate, endDate }) {
    state.startDate = startDate
    state.endDate = endDate
  },
  [types.SET_UNIT] (state, unit) {
    state.searchUnit = unit
  },
  [types.SET_STORE_HOT_SALE] (state, storeHotSale) {
    state.storeHotSale = storeHotSale
  },
  [types.SET_STORE_HOT_SALE_REPORT_DATA] (state, storeHotSaleReport) {
    state.storeHotSaleReport.push(storeHotSaleReport)
  },
  [types.CLEAR_STORE_HOT_SALE_REPORT_DATA] (state) {
    Vue.set(state, 'storeHotSaleReport', [])
  }
}
